<!-- Loading analizando Lance -->
<div
  class="card-bid orange center"
  *ngIf="isStatus === 'AGUARDANDO' && user.type !== 'MASTER'"
>
  <div class="loading">
    <div class="scale">
      <page-loading></page-loading>
    </div>
  </div>

  <div class="left">
    <h3>Aguarde...</h3>
    <h4>seu lance está sendo analisado</h4>
  </div>
</div>

<!-- LANCE - Lote marcado como vendido -->
<div
  class="card-bid"
  [ngClass]="isStatus !== 'ACEITO' ? 'white' : 'green'"
  *ngIf="
    isStatus !== 'AGUARDANDO' &&
    animal_obj?.status === 'VENDIDO'
  "
>
  <div class="left">
    <h4 *ngIf="isStatus !== 'ACEITO'">Lote {{ animal_obj.lot || '' }} encerado!</h4>
    <h4 *ngIf="isStatus === 'ACEITO'">Seu lance é o vencendor!</h4>

    <div class="winning-bid" *ngIf="isStatus === 'ACEITO'">
      <i icon="check" *ngIf="isStatus === 'ACEITO'"></i>
      <h5>
        <strong>{{ attual_bid - increment | currency : 'BRL' }}</strong>
      </h5>
      <h5>{{ list_bids.length > 0 ? (list_bids[0].updated_at | date : 'dd/MM/yyyy HH:mm a' ): ''}}</h5>
    </div>
  </div>
</div>

<!-- LANCE - Lote aberto para lance -->
<div
  class="card-bid orange"
  *ngIf="
    isStatus !== 'AGUARDANDO' &&
    animal_obj?.status !== 'VENDIDO' &&
    ['OPEN', 'REAL_TIME'].includes(bid_status)
  "
>
  <div class="left">
    <h4>Próximo Lance</h4>
    <h1>{{ next_bid | currency : 'BRL' }}</h1>
  </div>

  <div class="right">
    <!-- Lance online -->
    <button
      mat-button
      class="c_white"
      (click)="openOnlineBidPopup()"
      *ngIf="isStatus !== 'ACEITO' || user.type === 'MASTER'"
    >
      DAR LANCE
    </button>
    <div *ngIf="isStatus === 'ACEITO'" style="width: 100%; height: 30px"></div>
  </div>
</div>

<!-- LANCE - Lance Atual -->
<div
  class="card-bid"
  [ngClass]="['RECUSADO', 'SUPERADO'].includes(isStatus) ? 'red' : isStatus !== 'ACEITO' ? 'white' : 'green'"
  *ngIf="
    isStatus !== 'AGUARDANDO' &&
    animal_obj?.status !== 'VENDIDO' &&
    ['REAL_TIME', 'OPEN'].includes(bid_status)
  "
>
  <div class="left">
    <h4 *ngIf="isStatus === ''">Lance Atual</h4>
    <h4 *ngIf="isStatus === 'ACEITO'">Seu lance está vencendo!</h4>

    <h4 *ngIf="isStatus === 'SUPERADO'">Seu lance foi superado!</h4>
    <h4 *ngIf="isStatus === 'RECUSADO'">Seu lance foi recusado!</h4>

    <div class="winning-bid">
      <i icon="check" *ngIf="isStatus === 'ACEITO'"></i>
      <h5>
        <strong>{{ attual_bid | currency : 'BRL' }}</strong>
      </h5>
      <!-- <h5>{{ opened_schedule.transaction.last_auction_bid.updated_at | date : 'dd/MM/yyyy HH:mm a' }}</h5> -->
    </div>
  </div>
</div>
